module.exports = __webpack_public_path__ + "img/f71395455a42560b17b75c49e33db4db.png";